import { AppChannel, Channel } from "@/config/channel"
import { HeaderVariants } from "./factory-header.types"
import { PokerstarsBaseHeader } from "./pokerstars"
import {
  SisalBaseHeader,
  HomePageLogoLink as SisalLogoLink,
  SisalQuestionarioHeader,
  SisalUploadDocHeader,
} from "./sisal"

type FactoryHeaderProps = {
  variant?: HeaderVariants
  siteid?: Channel
}

const AppChannelsWithoutHeader: Channel[] = [
  AppChannel.ClientDesktopSisalPoker,
  AppChannel.AppSisalPoker,
  AppChannel.AppCasinoHub,
  AppChannel.AppMobileScommesse,
  AppChannel.AppLottery,
]

export function FactoryHeader({
  variant = HeaderVariants.base,
  siteid,
}: FactoryHeaderProps) {
  const hideSiteHeader =
    siteid != null && AppChannelsWithoutHeader.includes(siteid)

  if (hideSiteHeader) return null

  if (process.env.APP_VENDOR === "pokerstars") {
    return <PokerstarsBaseHeader />
  }
  /* -----------------------------------------------------------------------------------------------*/
  const Component = {
    [HeaderVariants.base]: SisalBaseHeader,
    [HeaderVariants.questionario]: SisalQuestionarioHeader,
    [HeaderVariants.uploadDoc]: SisalUploadDocHeader,
  }[variant]

  return <Component homePageLogoLink={<SisalLogoLink siteid={siteid} />} />
}
